import React from 'react';
import {
	Avatar,
	Button,
	Card,
	CardActionArea,
	CardContent,
	Paper,
	Slide,
	Typography,
	useTheme, Zoom,
} from "@mui/material";
import {actions} from "../../../../../utils/dictionaries/Actions";
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {useHistory} from "react-router-dom";
import clsx from "clsx";
import {getUserName} from "../../../../../utils/GenericUtils";

export const AzioniPaper = () => {
	const classes = innerStyle();
	let theme = useTheme();
	let history = useHistory();
	
	return (
		<React.Fragment>
			<Slide direction={"right"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "100ms"}}>
				<Paper className={classes.paper} component={"section"}>
					<Typography variant={"h4"} component={"h1"} style={{paddingLeft: 6}}>
						<b>Ciao {getUserName()}!👋</b>
					</Typography>
					<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
						Clicca sull'azione che desideri svolgere
					</Typography>
					<div className={clsx(classes.flexStart, classes.centerOnMd)}>
						{
							Object.entries(actions).map(([key, val], index) => {
								return (
									<Zoom key={key} in={true} style={{
										transitionDelay: (index + "00ms")
									}}>
										<Card className={classes.card} elevation={0}>
											<CardActionArea className={classes.cardActionArea}
											                style={{backgroundColor: theme.palette.mode === "light" ? val.bgColor : val.bgColorDark}}>
												<CardContent style={{position: "relative"}}>
													<Avatar style={{
														backgroundColor: theme.palette.mode === "light" ? val.bgColor : val.bgColorDark,
														color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor
													}}>
														{theme.palette.mode === "light" ? val.iconNoStyle : val.iconDark}
													</Avatar>
													<Avatar style={{
														backgroundColor: theme.palette.mode === "light" ? val.bgColor : val.bgColorDark,
														color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor,
														position: "absolute",
														bottom: 0,
														right: 0,
														opacity: 0.06,
														transform: "scale(4)",
													}}>
														{theme.palette.mode === "light" ? val.iconRoundedNoStyle : val.iconDark}
													</Avatar>
													<Typography
														className={classes.hideOnMd}
														style={{color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor}}>
														<b>{val.name}</b>
													</Typography>
												</CardContent>
											</CardActionArea>
										</Card>
									</Zoom>
								)
							})
						}
					</div>
					<div className={classes.flexEnd}>
						<Button className={classes.button} style={{borderRadius: 22}} variant={"contained"} disableElevation
						        onClick={() => history.push("/v2/gestione/azioni")}>
							<b>Mostra nel dettaglio</b>
						</Button>
					</div>
				</Paper>
			</Slide>
		</React.Fragment>
	);
};
